/**
 * Homepage Translations
 * Page-specific translations for homepage
 * Dynamically loads translations based on language
 */

// Import all translation files
import enTranslations from './en.json';
import deTranslations from './de.json';
import itTranslations from './it.json';
import esTranslations from './es.json';
import frTranslations from './fr.json';
import ptTranslations from './pt.json';
import nlTranslations from './nl.json';
import plTranslations from './pl.json';
import svTranslations from './sv.json';
import noTranslations from './no.json';
import daTranslations from './da.json';
import fiTranslations from './fi.json';
import csTranslations from './cs.json';
import huTranslations from './hu.json';
import roTranslations from './ro.json';
import elTranslations from './el.json';
import idTranslations from './id.json';

// Export translations object with language keys
const homepageTranslations = {
  en: enTranslations,
  de: deTranslations,
  it: itTranslations,
  es: esTranslations,
  fr: frTranslations,
  pt: ptTranslations,
  nl: nlTranslations,
  pl: plTranslations,
  sv: svTranslations,
  no: noTranslations,
  da: daTranslations,
  fi: fiTranslations,
  cs: csTranslations,
  hu: huTranslations,
  ro: roTranslations,
  el: elTranslations,
  id: idTranslations
};
export default homepageTranslations;
